import { useFormContext } from 'react-hook-form'
import SelectTagInputWithCheckboxes from '@/components/SelectTagInputWithCheckboxes'
import type { EditPostFormData } from '../types'

interface FormTerritoriesFieldProps {
  items: { id: string; name: string }[]
  loading: boolean
}

export function FormTerritoriesField({ items, loading }: FormTerritoriesFieldProps) {
  const { watch, setValue, formState } = useFormContext<EditPostFormData>()
  const value = watch('territories') || []
  return (
    <div className="space-y-2">
      <label className="text-sm">
        Territórios: <span className="text-red-500">*</span>
      </label>
      <SelectTagInputWithCheckboxes
        value={value}
        onChange={(v) => setValue('territories', v, { shouldDirty: true })}
        placeholder="Pesquisar"
        items={items}
        loading={loading}
        required
      />
      {formState.errors.territories && (
        <p className="text-sm text-red-500">{formState.errors.territories.message}</p>
      )}
    </div>
  )
}
